module.exports = __webpack_public_path__ + "static/logo-mayapada-healthcare-363d4808ac728dd7d069eef093ef48f2.png";